import { Redirect } from "react-router";
import { useSelector } from "react-redux";
import queryString from "query-string";
import React, { useEffect, useState, lazy, Suspense } from "react";
import store from "store";
import Icon from "@identitybuilding/idb-react-iconlib";
// import SearchBar from "./SearchBar";
// import WeCare from '../privacy/WeCare'
// import Map from '@identitybuilding/idb-react-100-percent-local'
// import InfoBar from "../_general/Infobar"
// import Redirects from '../_general/Redirects'
// import Footer from "../_general/Footer";
// import Navigation from "../_general/Navigation";
import Meta from "../_general/Meta";
import Axios from "axios";
import AlternateSearchBar from "./AlternateSearchBar";
// const groupBy = require('lodash.groupby');
const SearchBar = lazy(() => import("./SearchBar"));

const WeCare = lazy(() => import("../privacy/WeCare"));
const InfoBar = lazy(() => import("../_general/Infobar"));
const Map = lazy(() => import("@identitybuilding/idb-react-100-percent-local"));
const Redirects = lazy(() => import("../_general/Redirects"));
const Footer = lazy(() => import("../_general/Footer"));
const Navigation = lazy(() => import("../_general/Navigation"));
const is100ProcentLokaal = window.location.href.includes('100procentlokaal') || window.location.href.includes('100pourcentlocale');

const SearchEngine = (props) => {
  const { lang, translate } = useSelector((state) => state.general);
  const map = useSelector((state) => state.map.show);
  const nis = useSelector((state) => state.general.nis);
  let search = useSelector((state) => state.search);

  const [redirect, setRedirect] = useState(false);
  const keyboard = props.match && props.match.params.keyboard;
  const vkb_params = queryString.parse(keyboard);
  const [data, setData] = useState("");
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    // Clear mapSelection from localStorage if the site matches the specified URLs
    const currentURL = window.location.href;
    if (
      currentURL === "http://localhost:3000/" ||
      currentURL === "https://ondernemersnetwerk.be/" ||
      currentURL === "https://reseauentrepreneurs.be/"
    ) {
      localStorage.removeItem("mapSelection");
    }

  }, []);

  useEffect(() => {
    // const getData = async () => {
    // 	let result = await searchLocation({ translate: translate, name: nis, nis: nis, lang: lang });
    // 	setData(result)
    // }

    // nis && setTimeout(() => { getData(); }, 100)
    if (nis && !isNaN(Number(nis))) {
      let location = "";
      const location_by_name_model = require("../../models/LocationByName").default;

      let option = {
        from: 0,
        size: 30,
        query: {
          query_string: {
            query: `${nis}`,
            fields: [
              'pkancode',
              'nis_code',
              'submunicipality_set.pkancode',
            ],
            tie_breaker: 0.3,
          },
        },
      };
      Axios.get(`${process.env.REACT_APP_BASE_MEDIA_URL2}municipalities/_search`, {
        auth: {
          username: `${process.env.REACT_APP_ESUSERNAME}`,
          password: `${process.env.REACT_APP_ESPSW}`,
        },
        params: {
          source_content_type: "application/json",
          source: JSON.stringify(option),
        },
      })
        .then((res) => {
          const hits = res.data.hits.hits;
          if (hits && hits.length > 0) {
            let data = hits[0]._source;
            location = location_by_name_model(translate, data, lang, "municipality");

            let oldPath = window.location.href;
            let newPath = "";
            if (lang === "nl") {
              if (location.nameNL && location.nameNL !== "") {
                newPath = oldPath.replace(/^[^.]*/, location.nameNL.toLowerCase());
              } else if (location.nameFR && location.nameFR !== "") {
                newPath = oldPath.replace(/^[^.]*/, location.nameFR.toLowerCase());
              } else {
                newPath = oldPath.replace(/^[^.]*/, location.nameDE.toLowerCase());
              }
            } else {
              if (location.nameFR && location.nameFR !== "") {
                newPath = oldPath.replace(/^[^.]*/, location.nameFR.toLowerCase());
              } else if (location.nameNL && location.nameNL !== "") {
                newPath = oldPath.replace(/^[^.]*/, location.nameNL.toLowerCase());
              } else {
                newPath = oldPath.replace(/^[^.]*/, location.nameDE.toLowerCase());
              }
            }

            window.location.href = `https://${newPath
              .replace("(stad)", "")
              .replace("(ville)", "")
              .replace("(stadt)", "")
              .replace("city", "")
              .replace(" ", "")
              .replace("œ", "oe")
              .replace("fontaine-l'évêque", "fontaine-levêque")
              .replace("'sgravenbrakel", "s-gravenbrakel")
              }`;
          } else {
            console.warn("No hits returned for the query");
            // Handle the case where no hits are returned
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    }


    scrollTo();
    setLoaded(true)
    // setData(props.location[0])
  }, []);

  // seperate this, as we don't want the getData function to be called again
  useEffect(() => {
    if (keyboard) {
      if (vkb_params)
        if (Object.keys(vkb_params)[0] === "vkb") {
          if (vkb_params.vkb) {
            store.set("vkb", vkb_params);
          } else {
            store.remove("vkb");
          }
          setRedirect(true);
        }
    }
  }, [keyboard, vkb_params]);

  // This makes sure that when going to the homepage, you're not scrolled down
  const scrollTo = (e) => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <React.Fragment>
      {window.location.href === "https://www.100procentlokaal.be/" ||
        window.location.href === "https://vlaanderen.100procentlokaal.be/" ||
        window.location.href === "https://100procentlokaal.be/" ||
        window.location.href === "https://www.dev.100procentlokaal.be/" ||
        window.location.href === "https://www.100pourcentlocale.be/" ||
        window.location.href === "https://flandre.100pourcentlocale.be/" ||
        window.location.href === "https://100pourcentlocale.be/" ||
        window.location.href === "https://www.dev.100pourcentlocale.be/" ||
        window.location.href === "https://www.osntest.be/map" ||
        window.location.href === "https://www.osnsocial.be/map" ||
        window.location.href === "http://localhost:3000/map" ? (
        <React.Fragment>
          <Meta
            // description={'100% Lokaal, zoek alle Belgische lokale ondernemers! Wordt dit privacyvriendelijk project al ondersteunt door jouw Stad of Gemeente?'}
            description={
              "Op zoek naar ik koop lokaal? Dan vind je alleen op 100%lokaal alle Belgische lokale handelaars en ondernemers! Wordt dit privacyvriendelijk project al ondersteunt door jouw Stad of Gemeente?"
            }
            logo={data.local_logo}
            title={translate("percent_local")}
          />
          <Suspense
            fallback={
              <div className="loadingScreen">
                <Icon name="Loading" animated />
              </div>
            }
          >
            <Map lang={lang} type={window.location.hostname.includes('vlaanderen.100procentlokaal') || window.location.hostname.includes('flandre.100pourcentlocale') ? 'vlaanderen' : 'all'} />
          </Suspense>
        </React.Fragment>
      ) : loaded && (
        <div
          className="home"
          style={{
            display: "flex",
            flexDirection: "column",
            filter: map ? "blur(1px)" : undefined,
          }}
        >
          <div className="Environment" id="top">
            {nis && search.municipality && (
              <Suspense fallback={<div></div>}>
                <InfoBar {...props} data={search.municipality} />
              </Suspense>
            )}
            <Suspense fallback={<div style={{ width: "100%" }}></div>}>
              <Navigation {...props} />
            </Suspense>
            <div id="searchEngineWrapper">
              <div className={`searchEngine ${nis ? "active" : ""}`}>
                {nis ? (
                  <div style={{ animation: "logoIntro .5s" }}>
                    <div id="logo_municipality_local_wrapper">
                      {search.municipality &&
                        search.municipality.active_logo &&
                        search.municipality.local_logo ? (
                        // Manual made logo with municipality in 100PL logo
                        <img
                          alt={translate("esn_alt")}
                          className="logo_municipality_local"
                          src={`${search.municipality.local_logo.png_nl}`}
                        />
                      ) : // If logo with municipality in 100PL logo is not created, try to make itself with css
                        search.location.length > 0 &&
                          search.municipality.active_logo &&
                          !search.municipality.local_logo ? (
                          <div>
                            <div className="logo_municipality_wrapper">
                              <img
                                alt={translate("esn_alt")}
                                className="logo_municipality"
                                src={`${search.municipality.logo}`}
                              />
                            </div>
                            <img
                              alt="100% lokaal logo"
                              className="logo_municipality_local"
                              src={`${process.env.REACT_APP_BASE_MEDIA_URL}/static/public/images/100percent_only_marker.png`}
                            />
                          </div>
                        ) : (
                          search.location.length > 0 && (
                            // just normal logo
                            <img
                              alt={translate("pl_alt")}
                              className="logo_municipality"
                              src={require(`../../library/imgs/logos/pl/logo_pl_${lang}.svg`)}
                            />
                          )
                        )}
                    </div>
                    <h1 style={{ marginTop: "0" }}>
                      {translate("search_engine_desc_local")}{" "}
                      {
                        <strong>
                          {nis.charAt(0).toUpperCase() + nis.slice(1)}
                        </strong>
                      }
                    </h1>
                  </div>
                ) : (
                  <div style={{ animation: "logoIntro .5s" }}>
                    <img
                      alt={translate("esn_alt")}
                      className="logo"
                      src={require(`../../library/imgs/logos/esn/logo_esn_${lang}.svg`)}
                    />
                    <h1>
                      {nis
                        ? translate("search_engine_desc_local")
                        : translate("search_engine_desc")}{" "}
                      {nis && (
                        <strong>
                          {nis.charAt(0).toUpperCase() + nis.slice(1)}
                        </strong>
                      )}
                    </h1>
                  </div>
                )}

                <Suspense fallback={<div></div>}>
                  {is100ProcentLokaal ? (
                    <AlternateSearchBar options props={props} />
                  ) : (
                    <SearchBar options props={props} />
                  )}
                </Suspense>

              </div>
            </div>
            <Suspense fallback={<div></div>}>
              <Footer />
            </Suspense>
          </div>
          <WeCare />
          {redirect && <Redirect to="/" />}
          <Redirects {...props} />
        </div>
      )}
    </React.Fragment>
  );
};

export default SearchEngine;
